module.exports = __webpack_public_path__ + "static/img/1.0051769.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/生活照/1.jpg
// module id = HKyb
// module chunks = 0